import "./address-editor-form.scss";
import FontBody3 from "../../../../../../components/fonts/font-body3/font-body3";
import FontBody4 from "../../../../../../components/fonts/font-body4/font-body4";
import Table from "../../../../../../components/table/table";

import { AddressEditorFormCell } from "./address-editor-form-cell/address-editor-form-cell";
import { PolicyAddressRequirementsStore } from "../../../../stores/policy-address-requirements-store";
import { observer } from "mobx-react";

type AddressEditorFormProps = {
    addressRequirements: PolicyAddressRequirementsStore;
};

export const AddressEditorForm = observer(({
    addressRequirements,
}: AddressEditorFormProps) => {
    return (
        <div className="address-editor-form--wrapper">
            <div className="address-editor-form-header">
                <FontBody4>
                    Customize Address Fields Display & Validation
                </FontBody4>
                <FontBody3>
                    Configure which customer information fields are shown on the
                    portal and set their validation requirements.
                </FontBody3>
            </div>
            <div className="address-editor-form-table--wrapper">
                <Table
                    columns={[
                        {
                            content: "Field",
                            width: {
                                value: 1,
                                type: "fr",
                            },
                        },
                        {
                            content: "Display?",
                            width: {
                                value: 1,
                                type: "fr",
                            },
                        },
                        {
                            content: "Mandatory?",
                            width: {
                                value: 1,
                                type: "fr",
                            },
                        },
                    ]}
                >
                    <AddressEditorFormCell
                        label="Email"
                        display={addressRequirements.email.display}
                        mandatory={addressRequirements.email.required}
                        onDisplayChange={(v) => addressRequirements.setEmailDisplay(v)}
                        onMandatoryChange={(v) =>
                            addressRequirements.setEmailRequired(v)
                        }
                    />
                    <AddressEditorFormCell
                        label="Phone"
                        display={addressRequirements.phone.display}
                        mandatory={addressRequirements.phone.required}
                        onDisplayChange={(v) => addressRequirements.setPhoneDisplay(v)}
                        onMandatoryChange={(v) =>
                            addressRequirements.setPhoneRequired(v)
                        }
                    />
                    <AddressEditorFormCell
                        label="Country"
                        display={addressRequirements.country.display}
                        mandatory={addressRequirements.country.required}
                        onDisplayChange={(v) =>
                            addressRequirements.setCountryDisplay(v)
                        }
                        onMandatoryChange={(v) =>
                            addressRequirements.setCountryRequired(v)
                        }
                    />
                    <AddressEditorFormCell
                        label="State/Province/Region"
                        display={addressRequirements.state.display}
                        mandatory={addressRequirements.state.required}
                        onDisplayChange={(v) => addressRequirements.setStateDisplay(v)}
                        onMandatoryChange={(v) =>
                            addressRequirements.setStateRequired(v)
                        }
                    />
                    <AddressEditorFormCell
                        label="Address"
                        display={addressRequirements.address_line.display}
                        mandatory={addressRequirements.address_line.required}
                        onDisplayChange={(v) =>
                            addressRequirements.setAddressLineDisplay(v)
                        }
                        onMandatoryChange={(v) =>
                            addressRequirements.setAddressLineRequired(v)
                        }
                    />
                    <AddressEditorFormCell
                        label="Address Line 2"
                        display={addressRequirements.apartment.display}
                        mandatory={false}
                        onDisplayChange={(v) =>
                            addressRequirements.setApartmentDisplay(v)
                        }
                        onMandatoryChange={() => {}}
                        isAlwaysOptional
                    />
                    <AddressEditorFormCell
                        label="Zip"
                        display={addressRequirements.zip.display}
                        mandatory={addressRequirements.zip.required}
                            onDisplayChange={(v) => addressRequirements.setZipDisplay(v)}
                        onMandatoryChange={(v) =>
                            addressRequirements.setZipRequired(v)
                        }
                    />
                    <AddressEditorFormCell
                        label="City"
                        display={addressRequirements.city.display}
                        mandatory={addressRequirements.city.required}
                        onDisplayChange={(v) => addressRequirements.setCityDisplay(v)}
                        onMandatoryChange={(v) =>
                            addressRequirements.setCityRequired(v)
                        }
                    />
                </Table>
            </div>
        </div>
    );
});
